import './ContactList.scss';
export class ContactListController {
    constructor() {
        this.handleContactToogle = (contact) => {
            if (this.checkableContacts) {
                if (contact.checked) {
                    this.addContact(contact);
                    this.addCounter({ contact: contact });
                }
                else {
                    this.deleteContact(this.checkedContacts, contact);
                    if (contact.template === 'builder') {
                        this.deleteCounter({ contact: contact });
                    }
                }
            }
        };
        this.handleContactDispose = (contact) => {
            if (this.disposableContacts) {
                if (this.onContactDispose) {
                    this.onContactDispose(contact);
                }
                else if (contact.checked) {
                    contact.checked = false;
                    this.deleteContact(this.contacts, contact);
                }
            }
        };
        this.handleContactDelete = (contact) => {
            this.deleteContact(this.contacts, contact);
        };
    }
    addContact(contact) {
        this.checkedContacts.push(contact);
        this.checkedContacts.sort((a, b) => a.created < b.created ? 1 : -1);
        this.flowCheckedRouter({ contact: contact });
    }
    deleteContact(contacts, contact) {
        const indexToRemove = contacts.findIndex((c) => contact.id === c.id);
        if (indexToRemove === -1) {
            return;
        }
        for (let index = indexToRemove; index < contacts.length - 1; index++) {
            contacts[index] = contacts[index + 1];
        }
        contacts.pop();
        this.flowUncheckedRouter({ contact: contact });
    }
    isBlocked(contact) {
        if (this.blockableContacts && this.blockingRule) {
            return this.blockingRule(contact);
        }
        else {
            return false;
        }
    }
}
